import React, { createContext } from 'react';

const SchedulingContext = createContext({});

export function SchedulingProvider({ children, value }) {
    return <SchedulingContext.Provider value={value}>{children}</SchedulingContext.Provider>;
}

export default SchedulingContext;
